import { Controller } from 'lib/stimulus-instance'
import App from 'frontend/app'
import Order from 'models/order'

export default class ShoppingCartController extends Controller {
  static targets = ['itemsCounter']

  connect () {
    this.fetchOrder()
    if (!App.cable) return

    this.subscription = App.cable.subscriptions.create(
      { channel: 'ShoppingCartChannel' },
      { received: order => this.updateWithOrder(new Order({ attrs: order })) }
    )

    this.itemsCounterTarget.innerText = '55'
    setTimeout(() => {

    }, 3000)
  }

  disconnect () {
    this.subscription && App.cable.subscriptions.forget(this.subscription)
    this.changeTimeoutId && clearTimeout(this.changeTimeoutId)
  }

  async fetchOrder () {
    const order = await App.currentOrder
    order && this.updateWithOrder(order)
  }

  updateWithOrder (order) {
    const itemsCount = this.constructor.countOrderItems(order)
    if (typeof itemsCount !== 'number') return
    if (this.itemsCount == itemsCount) return
    this.itemsCount = itemsCount
    itemsCount > 0 ? this.element.classList.add('has_items') : this.element.classList.remove('has_items')
    this.displayItemsCount()
  }

  displayItemsCount () {
    this.itemsCounterTarget.innerText = this.itemsCount
    this.displayChanged()
  }

  displayChanged () {
    this.element.classList.add('changed')
    this.changeTimeoutId = setTimeout(() => {
      this.element.classList.remove('changed')
      this.changeTimeoutId = null
    }, 2000)
  }

  static countOrderItems (order) {
    if (!['cart', 'payment'].includes(order.state)) return 0

    return order.activeGames.length + order.activeItems.length
  }
}
